<template>
  <GridBase our-brand>
    <h2><TextBlock file="about/our-brand-h2" class="pre-line" /></h2>
    <section class="sec1">
      <div class="img j"></div>
      <h3>GAK History</h3>
      <ul>
        <li>
          <dl>
            <dt><TextBlock file="about/our-brand-t1" class="pre-line" /></dt>
            <dd><TextBlock file="about/our-brand-t2" class="pre-line" /></dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt><TextBlock file="about/our-brand-t3" class="pre-line" /></dt>
            <dd><TextBlock file="about/our-brand-t4" class="pre-line" /></dd>
          </dl>
        </li>
      </ul>
    </section>
    <section class="sec2">
      <h3>Brand Identity</h3>
      <img src="/img/about/brand/brand-logo.png" alt="" class="logo j" />
      <dl>
        <dt><TextBlock file="about/our-brand-t5" class="pre-line" /></dt>
        <dd><TextBlock file="about/our-brand-t6" class="pre-line" /></dd>
      </dl>
      <div>
        <TextBlock file="about/our-brand-t7" class="pre-line" />
        <ul>
          <li>
            <img src="/img/about/brand/brand-mark-1.png" alt="" class="mark" />
            <span>Basic</span>
          </li>
          <li>
            <img src="/img/about/brand/brand-mark-2.png" alt="" class="mark" />
            <span>Line</span>
          </li>
          <li>
            <img src="/img/about/brand/brand-mark-3.png" alt="" class="mark" />
            <span>Solid</span>
          </li>
        </ul>
      </div>
    </section>
    <section class="sec3">
      <h3><TextBlock file="about/our-brand-t8" class="pre-line" /></h3>
      <dl>
        <dt><TextBlock file="about/our-brand-t9" class="pre-line" /></dt>
        <dd><TextBlock file="about/our-brand-t10" class="pre-line" /></dd>
      </dl>
      <div class="toggle-wrap">
        <div class="toggle-box">
          <input type="checkbox" id="btn-chk" class="input-box" @click="toggleSwitch">
          <label for="btn-chk" class="label-box"></label>
        </div>

        <!-- toggle 버튼 클릭 시, switch 클래스 적용 -->
        <div class="toggle-inner">
          <ul class="logo-list">
            <li class="logo-inner type1">
              <p>Official type</p>
              <div class="logo-type">
                <div class="logo-guide">
                  <span class="logo-img"></span>
                  <span class="logo-img"></span>
                </div>
                <div v-if="dark" class="logo-detail">
                  <ul>
                    <li>
                      <dl>
                        <dt><i class="square"></i><span>GAK DARK GREY 1</span></dt>
                        <dd><s>R/G/B</s><s>64/64/64</s></dd>
                        <dd><s>C/M/Y/K</s><s>0/0/0/75</s></dd>
                        <dd><s>HEX</s><s>#404040</s></dd>
                      </dl>
                    </li>
                    <li>
                      <dl>
                        <dt><i class="square"></i><span>GAK DARK GREY 2</span></dt>
                        <dd><s>R/G/B</s><s>13/13/13</s></dd>
                        <dd><s>C/M/Y/K</s><s>0/0/0/15</s></dd>
                        <dd><s>HEX</s><s>#0D0D0D</s></dd>
                      </dl>
                    </li>
                  </ul>
                </div>
                <div v-else class="logo-detail">
                  <ul>
                    <li>
                      <dl>
                        <dt><i class="square"></i><span>GAK WHITE</span></dt>
                        <dd><s>R/G/B</s><s>255/255/255</s></dd>
                        <dd><s>C/M/Y/K</s><s>0/0/0/0</s></dd>
                        <dd><s>HEX</s><s>#FFFFFF</s></dd>
                      </dl>
                    </li>
                    <li>
                      <dl>
                        <dt><i class="square"></i><span>GAK LIGHT GREY</span></dt>
                        <dd><s>R/G/B</s><s>217/217/217</s></dd>
                        <dd><s>C/M/Y/K</s><s>0/0/0/15</s></dd>
                        <dd><s>HEX</s><s>#D9D9D9</s></dd>
                      </dl>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
            <li class="logo-inner type2">
              <p>Abridged type</p>
              <div class="logo-type">
                <div class="logo-guide">
                  <span class="logo-img"></span>
                </div>
              </div>
            </li>
            <li class="logo-inner type3">
              <p>Version with region name</p>
              <div class="logo-type">
                <div class="logo-guide">
                  <span class="logo-img"></span>
                  <span class="logo-img"></span>
                </div>
                <div class="logo-guide">
                  <span class="logo-img"></span>
                </div>
                <div class="logo-guide">
                  <span class="logo-img"></span>
                </div>
              </div>
            </li>
            <li class="logo-inner type4">
              <p>Korean version</p>
              <div class="logo-type">
                <div class="logo-guide">
                  <span class="logo-img"></span>
                  <span class="logo-img"></span>
                </div>
                <div class="logo-guide">
                  <span class="logo-img"></span>
                  <span class="logo-img"></span>
                </div>
              </div>
            </li>
            <li class="logo-inner type5">
              <p>Symbol utilization</p>
              <div class="logo-type">
                <ul>
                  <li class="logo-guide">
                    <span class="logo-img"></span>
                    <span>Basic</span>
                  </li>
                  <li class="logo-guide">
                    <span class="logo-img"></span>
                    <span>Line</span>
                  </li>
                  <li class="logo-guide">
                    <span class="logo-img"></span>
                    <span>Solid</span>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>

        <div class="download-inner">
          <a href="/static/20231222_Data_Center_Gak_Brand_Guide.ai" class="btn-down" target="_blank" download>Download BI guidelines in AI</a>
          <a href="/static/20231222_Data_Center_Gak_Brand_Guide.pdf" class="btn-down" target="_blank" download>Download BI guidelines in PDF</a>
        </div>
      </div>
    </section>
    <quick-link>
      <quick-link-item><router-link to="/gak/gak-chuncheon">GAK <br class="hidden-lg-up" />Chuncheon</router-link></quick-link-item>
    </quick-link>
  </GridBase>
</template>
<script>
import GridBase from '@/views/components/GridBase';
import QuickLink from '@/views/components/QuickLink';
import QuickLinkItem from '@/views/components/QuickLinkItem';
import TextBlock from '@/views/components/TextBlock';
export default {
  components: { TextBlock, QuickLinkItem, QuickLink, GridBase },
  data() {
    return {
      dark: true
    }
  },
  methods: {
    toggleSwitch() {
      const container = document.querySelector('.toggle-inner');
      container.classList.toggle('switch');

      if (container.classList.contains('switch')) {
        this.dark = false;
      } else {
        this.dark = true;
      }
    }
  }
};
</script>
